import {useSetting} from "../contexts/setting";
import {useCurrentSet} from "./useCurrentSet";
import {supportsReleaseSocialMediaFormatting} from "../libs/releaseSocialMediaFormatting";

export function useReleaseSocialMediaFormatting() {
  const {channel, type} = useSetting();
  const selectedSet = useCurrentSet();
  return supportsReleaseSocialMediaFormatting(channel.value, type.value, selectedSet);
}
